import React from "react";
import { Badge } from "../ui/badge";
import { cn, getStatusClass, getStatusLabel, getPriorityClass, getPriorityLabel } from "../../lib/utils";

export function StatusBadge({ status, className }) {
  return (
    <Badge
      variant="secondary"
      className={cn(
        "font-medium text-xs",
        getStatusClass(status),
        className
      )}
    >
      {getStatusLabel(status)}
    </Badge>
  );
}

export function PriorityBadge({ priority, className }) {
  return (
    <Badge
      variant="secondary"
      className={cn(
        "font-medium text-xs",
        getPriorityClass(priority),
        className
      )}
    >
      {getPriorityLabel(priority)}
    </Badge>
  );
}
